import {
    ADD_POST_VIEW_INITIATE,
    ADD_POST_VIEW_SUCCESS,
    ADD_POST_VIEW_FAILURE,
} from "../../actions/reactions/addPostViewAction";

const initialState = {
    loading: false,
    data: null,
    error: null,
};

const addPostViewReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_POST_VIEW_INITIATE:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case ADD_POST_VIEW_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };

        case ADD_POST_VIEW_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default addPostViewReducer;
